export default "__VITE_ASSET__CgAjWbFb__"